import { render } from "./two-factor-auth.vue?vue&type=template&id=2c33ded0&ts=true"
import script from "./two-factor-auth.vue?vue&type=script&lang=ts"
export * from "./two-factor-auth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__